// @flow

import { v4 } from 'uuid';
import React from 'react';
import type { Node } from 'react';
import { article as ENUM_ARTICLE } from 'Enum';
import { META_SUBSCRIBER_NAME } from 'shared_services/riseart/meta/Meta';
import { CommonCategoryPage } from 'shared_components/pages/common/Category';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';

type Props = {
  staticContext: ?Object,
};

const PRELOADER_READ_CATEGORY_ID = v4();

/**
 * BlogCategoryPage
 * @returns
 */
export default function BlogCategoryPage({ staticContext }: Props): Node {
  return (
    <CommonCategoryPage
      staticContext={staticContext}
      mainQueryPreloaderId={PRELOADER_READ_CATEGORY_ID}
      articleType={ENUM_ARTICLE.type.TYPE_POST}
      showOnlyShowcaseItems
      listTitleTranslationKey="components.breadcrumbs.blog"
      listUrl={UrlAssembler.blogList()}
      translationPrefix="blogCategory"
      metaSubscriber={META_SUBSCRIBER_NAME.BLOG_CATEGORY_META}
    />
  );
}
